import { render, staticRenderFns } from "./118zzyh.vue?vue&type=template&id=3dc127f2&"
import script from "./118zzyh.vue?vue&type=script&lang=js&"
export * from "./118zzyh.vue?vue&type=script&lang=js&"
import style0 from "./118zzyh.vue?vue&type=style&index=0&id=3dc127f2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports